import { render, staticRenderFns } from "./ppmexport.vue?vue&type=template&id=1a66a687&scoped=true"
import script from "./ppmexport.vue?vue&type=script&lang=ts"
export * from "./ppmexport.vue?vue&type=script&lang=ts"
import style0 from "./ppmexport.vue?vue&type=style&index=0&id=1a66a687&prod&lang=css"
import style1 from "./ppmexport.vue?vue&type=style&index=1&id=1a66a687&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a66a687",
  null
  
)

export default component.exports